import PropTypes from 'prop-types';
import React from 'react';
import CardRender from '../shared/CardRender';
import ExtraCardBehavior from '../shared/ExtraCardBehavior';
import DocumentPreview from 'components/DocumentPreview';
import {FormattedMessage} from 'react-intl';
import {selectIsDavinci} from 'state/environment/environmentSelectors';
import {connect} from 'react-redux';
import styles from './DocumentViewDetails.css?module';

class DocumentViewDetails extends React.Component {
  render() {
    const {card, cardRender, isDavinci, fitToFrame} = this.props;
    const [documentId, revision] = cardRender
      ? cardRender.data.document.documentId.split(':')
      : [];
    const preview = documentId ? (
      <DocumentPreview
        id={documentId}
        width={isDavinci ? null : 320}
        fitToFrame={fitToFrame}
      />
    ) : null;

    const downloadAction = documentId ? (
      <a
        target="_blank"
        rel="noopener noreferrer"
        className={styles.Document__DownloadAction}
        href={`/api/data/v1/data-files/${documentId}${
          revision ? `/revisions/${revision}` : ''
        }?fileName=${card.title}`}
      >
        <i
          className={[
            styles.Document__DownloadIcon,
            'Icon--micro',
            'icon-arrow-down-24',
          ]}
        />
        <FormattedMessage
          id="Document__download-action"
          defaultMessage="Download File"
          description="Link to download a document."
        />
      </a>
    ) : null;

    return (
      <div>
        <div className={styles.container}>
          <div className={styles.contentContainer}>
            <div className={styles.content}>{preview}</div>
          </div>
        </div>
        {isDavinci ? null : (
          <ExtraCardBehavior>{downloadAction}</ExtraCardBehavior>
        )}
      </div>
    );
  }
}

DocumentViewDetails.propTypes = {
  card: PropTypes.object.isRequired,
};

const wrappedClass = connect(state => ({
  isDavinci: selectIsDavinci(state),
}))(DocumentViewDetails);

export default CardRender(wrappedClass, () => ({
  imageAsDocument: true,
}));
